module.exports = __webpack_public_path__ + "img/mark.c3aec2c0.png";